<template>
	<div>
		<div id="markouter">
			<div style="flex:1;" @click.stop="$emit('cancel')"></div>
			<div class="markinner" v-show="!show_delete">
				<div class="textNickname">
					<div id="scroll_div">
						<span>{{item.comments_username}}:&nbsp;&nbsp;</span>
						<template v-for="(detail,index) in parsingEmoji(item.comments_content)">
							<span v-if="detail.type=='text'" :key="index">{{detail.value}}</span>
							<img class="emoji-img" v-else-if="detail.type=='image'" :src="face[detail.value]" alt=""
								:key="index" />
						</template>
						<img class="img" v-for="(item,index) in item.comments_photo" :src="item" alt=""
							:key="1000+index" />
					</div>
				</div>
				<div class="commoncss bordertop" @click="$emit('reply',item)">{{$t('comment.reply')}}</div>
				<div id="copy" class="copy-btn js-copy-btn commoncss bordertop" @click="copy">{{$t('comment.copy')}}
				</div>
				<div class="commoncss bordertop" @click.stop="deleteCommentConfirm" v-show="item.is_delete">
					{{$t('comment.delete')}}</div>
				<div class="grey_Line"></div>
				<div class="commoncss" @click.stop="$emit('cancel')">{{$t('comment.cancel')}}</div>
			</div>

			<div id="delect_inner" v-show="show_delete">
				<div class="delect_csstitle">{{$t('comment.delete_tips')}}</div>
				<div class="delect_css bordertop" @click.stop="deleteComment">{{$t('comment.delete_confirm')}}</div>
				<div class="grey_Line"></div>
				<div class="delect_css" @click.stop="$emit('cancel')">{{$t('comment.cancel')}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FaceHelper from '@/js/comment/Analysisimg.js'
	import face from '@/js/comment/face.js'
	import pc from '@/js/pc.js'
	import ClipboardJS from '@/js/clipboard.min.js'
	import {
		Toast
	} from 'vant'

	export default {
		props: {
			item: {}
		},
		data() {
			return {
				tip_ok: false,
				show_delete: false,
				showcommont: true,
				show_copysucc: false,
				isClick: true,
				face,
				is_deleting: false
			}
		},
		components: {

		},
		mounted() {
			const dom = document.querySelector('#scroll_div').children
			let scroll_divWidth = 0
			for (let i = 0; i < dom.length; i++) {
				scroll_divWidth += dom[i].offsetWidth
			}
			document.getElementById('scroll_div').style.width = scroll_divWidth + 10 + 'px'
		},
		methods: {
			parsingEmoji(str) {
				return FaceHelper.create(str).elements
			},
			deleteCommentConfirm() {
				this.show_delete = true
			},
			deleteComment() {
				if (this.is_deleting) return
				this.is_deleting = true
				this.$emit('delete', task => {
					task && task(this.item).then(() => {
						this.is_deleting = false
						this.$emit('cancel')
					}).catch((error) => {
						this.is_deleting = false
						this.$emit('cancel')
						console.log(error)
					})
				})
			},
			copy(text) {
				const clipboard = new ClipboardJS('.copy-btn', {
					text: trigger => {
						return this.item.comments_content
					}
				})
				clipboard.on('success', (e) => {
					Toast('复制成功')
					e.clearSelection()
				})
			},
		}


	}
</script>

<style scoped>
	#delect_inner {
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
		background: #fff;
	}

	#delect_div {
		width: 100%;
		height: 100%;
		position: fixed;
		/* left: 0; */
		top: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1001;
		border-top: 1px solid #ececec;
	}

	.delect_css {
		text-align: center;
		line-height: 2.05rem;
		height: 2.05rem;
		font-weight: bold;
		font-size: 16px;
		color: #000;
		cursor: pointer;
	}

	.delect_csstitle {
		text-align: center;
		line-height: 2.05rem;
		height: 2.05rem;
		font-weight: bold;
		font-size: 14px;
		color: #bebebe;
	}

	.img {
		width: 1.2rem;
		height: 1.2rem;
	}

	#copyTextselect,
	#docu {
		position: absolute;
		left: -10000px;
	}

	.copy-btn {
		border: none;
		background: none;
		width: 100%;
	}

	#markouter {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1001;
	}

	.markinner {
		width: 100%;
		background: #fff;
	}

	.textNickname {
		/*text-align: center;*/
		height: 2.13rem;
		line-height: 2.13rem;
		width: 88%;
		margin: 0 auto;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		overflow-y: hidden;

	}

	#scroll_div {
		width: 10000px;
		height: 2.13rem;
		font-size: 16px;
	}

	.commoncss {
		text-align: center;
		line-height: 2.05rem;
		height: 2.05rem;
		font-weight: bold;
		font-size: 16px;
		color: #000;
		cursor: pointer;
	}

	.bordertop {
		border-top: 1px solid #ececec;
	}

	.grey_Line {
		width: 100%;
		height: 0.21rem;
		background: #dedede;
	}

	.emoji-img,
	.emoji-wrap {
		width: 0.85rem;
		height: 0.85rem;
	}
</style>